<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList">
      <div slot="content-buttons">
        <div v-if="loading">
          <span>Aguarde, estamos processando o retorno, isso pode levar alguns segundos...</span>
          <Loading type="line" :center="false" />
        </div>
        <div v-else>
          <Alert type="info">
            <span>
              Selecione o arquivo de retorno
            </span>
            <br />
          </Alert>
          <FileUpload title="Carregar .ret ou .txt" classIcon="fa-solid fa-file-export"
            container="nixloc-shipment-return" accepted=".ret" allowed=".ret" :disabled="true"
            urlPost="/api/v1/adm/file-upload/upload" urlRemove="/api/v1/adm/file-upload/delete" :nameDataBase="file"
            v-model="file" :onLoad="processReturn" />
        </div>
      </div>
    </ViewTemplateConfiguration>
    <Modal title="Total Processado" :width="900" :height="750" v-if="showModal('billet')">
      <div class="div-btn-json">
        <Button title="Baixar JSON" classIcon="fa-solid fa-download" type="primary" size="small"
          :clicked="downloadJsonProcessed" />
      </div>
      <ScrollBar :minHeight="330" :maxHeight="330">
        <div v-for="billet in jsonProcessed">
          <div class="div-molded">
            <Molded>
              <b-row>
                <b-col sm="1">
                  <div class="div-icon">
                    <i class="fa-solid fa-barcode"></i>
                  </div>
                </b-col>
                <b-col sm="10">
                  <div v-if="billet.Pagador">
                    <span class="title"> Cliente: {{ billet.Pagador.Nome }}</span>
                  </div>
                  <div v-else>
                    <span class="title"> Cliente: Não Identificado</span>
                  </div>
                  <div v-for="ocorrencia in billet.Ocorrencias">
                    <hr class="hr">
                    <div class="badge badge-dark-primary" v-if="ocorrencia.Situacao == 'REGISTRO_CONFIRMADO'">
                      Registrado
                    </div>
                    <div class="badge badge-success" v-if="ocorrencia.Situacao == 'LIQUIDACAO'">
                      Liquidado
                    </div>
                    <div class="badge badge-danger" v-if="ocorrencia.Situacao == 'REGISTRO_REJEITADO'">
                      Rejeitado
                    </div>
                    <div class="badge badge-warning" v-if="ocorrencia.Situacao == 'BAIXA'">
                      Baixa
                    </div>
                    <div class="badge badge-danger" v-if="ocorrencia.Situacao == 'PROTESTO'">
                      Protestado
                    </div>
                    <div class="badge badge-danger" v-if="ocorrencia.Situacao == 'CANCELAMENTO_PROTESTO'">
                      Protesto Cancelado
                    </div>
                    <div class="badge badge-danger" v-if="ocorrencia.Situacao == 'CANCELAMENTO_ABATIMENTO'">
                      Cancelado
                    </div>
                    <div class="title">Descrição: <span class="title-description">{{ ocorrencia.Descricao }}</span>
                    </div>
                    <div v-if="ocorrencia.Info">
                      <span class="title">Emitido: {{ ocorrencia.Info.ValorPago | currency }}</span>
                      <span class="title"> - Juros: {{ ocorrencia.Info.JurosMora | currency }}</span>
                      <span class="title"> - Total: {{ ocorrencia.Info.ValorPago + ocorrencia.Info.JurosMora | currency
                      }}</span>
                      <span class="title"> - Vencimento: {{ ocorrencia.Info.DataDePagamento }}</span>

                    </div>
                    <div v-else>
                      <span class="title">{{ billet.Valor | currency }}</span>
                    </div>

                  </div>
                </b-col>
              </b-row>
            </Molded>
          </div>
        </div>
      </ScrollBar>
    </Modal>
  </div>
</template>

<script>
import ViewTemplateConfiguration from "@nixweb/nixloc-ui/src/component/template/ViewTemplateConfiguration";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import FileUpload from "@nixweb/nixloc-ui/src/component/forms/FileUpload";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "ReturnShipmentView",
  components: {
    ViewTemplateConfiguration,
    Button,
    Alert,
    FileUpload,
    Loading,
    Modal,
    Molded,
    ScrollBar
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/billing/shipment-return/get-all-return-shipment",
        showChecks: false,
        headerTable: [
          {
            field: "urlLogo",
            container: "nixloc-bank-logo",
            type: "image",
            classCssBody: "img-bank",
          },
          {
            field: "registeredDate",
            title: "Emissão",
            type: "dateTime",
          },
          {
            field: "fileName",
            title: "Arquivo",
            type: "text",
            iconSearch: true,
          },
          {
            field: "totalProcessed",
            title: "Total Processado",
            type: "link",
            eventName: "viewBilletProcessed",
            classCssTitle: "text-center",
            classCssBody: "text-center",
          },
          {
            type: "button",
            typeButton: "default",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            button: {
              title: "Baixar",
              classIcon: "fa-solid fa-download",
              type: "primary",
              size: "small",
              eventName: "downloadFileReturn",
            },
          }
        ],
      },
      file: "",
      loading: false,
      urlProcessReturn: "/api/v1/billing/shipment-return/process-return",
      jsonProcessed: [],
    };
  },
  computed: {
    ...mapGetters("generic", ["event", "showModal"]),
  },
  methods: {
    ...mapActions("generic", ["postApi"]),
    ...mapMutations("generic", ["openModal"]),
    processReturn() {
      this.loading = true;
      let self = this;
      setTimeout(function () {
        let obj = { any: self.file };
        let params = { url: self.urlProcessReturn, obj: obj, notNotifyToast: true };
        self.postApi(params).then((response) => {
          if (response.success) {
            self.file = "";
          } else {
            self.file = "";
          }
          self.loading = false;
        });
      }, 300);
    },
    download(fileName) {
      const downloadLink = document.createElement("a");
      downloadLink.href = `https://espaco.blob.core.windows.net/nixloc-shipment-return/${fileName}`;
      downloadLink.target = "_blank";
      downloadLink.click();
    },
    downloadJsonProcessed() {
      const dataStr = JSON.stringify(this.jsonProcessed, null, 2);
      const blob = new Blob([dataStr], { type: "application/json" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "total_processado.json";
      link.click();

      URL.revokeObjectURL(url);
    }
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "downloadFileReturn") {
          this.download(event.data.fileNameOriginal);
        }
        if (event.name == "viewBilletProcessed") {
          this.openModal("billet");
          let parsed = JSON.parse(event.data.jsonProcessed);

          this.jsonProcessed = parsed.sort((a, b) => {
            const nomeA = a.Pagador?.Nome?.toLowerCase() || "";
            const nomeB = b.Pagador?.Nome?.toLowerCase() || "";
            return nomeA.localeCompare(nomeB, "pt-BR");
          });
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.div-molded {
  margin-bottom: 10px;
  margin-right: 10px;
}

.div-icon {
  margin-top: 10px;
}

.title-description {
  font-style: italic;
  font-size: 12px;
}

.div-btn-json {
  margin-bottom: 20px;
}
</style>